import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Newspaper, Briefcase, Star, Bell, CreditCard, ChartCandlestick } from "lucide-react";
import axios from "axios";
import Cookies from "js-cookie";
import Logo from "./Logo";

const LinkedInHeader = ({ currentPage, setCurrentPage, mobileMenuOpen, setMobileMenuOpen, authStatus, setAuthStatus }) => {

  function logOut() {
    Cookies.remove('token');
    Cookies.remove('email');
    setAuthStatus(false);
  }

  return (
    <header className="linkedin-header bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Search */}
          <div className="flex items-center space-x-6 flex-1">
            <div className="flex-shrink-0">
              <button onClick={() => setCurrentPage('feed')} className="">
                <Logo textAlign="text-left" />
              </button>
            </div>
            
          </div>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center justify-end w-full max-w-md mx-auto">
            <button 
              onClick={() => setCurrentPage('feed')}
              className={`linkedin-nav-item ${['', 'feed'].includes(currentPage) ? 'active' : ''}`}
            >
              <Newspaper className="w-5 h-5" />
              <span className="text-xs mt-1">Feed</span>
            </button>
            <button 
              onClick={() => setCurrentPage('search')}
              className={`linkedin-nav-item ${currentPage === 'search' ? 'active' : ''}`}
            >
              <Search className="w-5 h-5" />
              <span className="text-xs mt-1">Search</span>
            </button>
            <button 
              onClick={() => setCurrentPage('ratings')}
              className={`linkedin-nav-item ${currentPage === 'ratings' ? 'active' : ''}`}
            >
              <Star className="w-5 h-5" />
              <span className="text-xs mt-1">Ratings</span>
            </button>
            <button 
              onClick={() => setCurrentPage('notifications')}
              className={`linkedin-nav-item ${currentPage === 'notifications' ? 'active' : ''}`}
            >
              <Bell className="w-5 h-5" />
              <span className="text-xs mt-1">Notifications</span>
            </button>
            <button 
              onClick={() => setCurrentPage('over-undervalued-companies')}
              className={`linkedin-nav-item ${currentPage === 'over-undervalued-companies' ? 'active' : ''}`}
            >
              <ChartCandlestick className="w-5 h-5" />
              <span className="text-xs mt-1">Undervalued</span>
            </button>
            <button 
              onClick={() => setCurrentPage('subscriptions')}
              className={`linkedin-nav-item ${currentPage === 'subscriptions' ? 'active' : ''}`}
            >
              <CreditCard className="w-5 h-5" />
              <span className="text-xs mt-1">Subscriptions</span>
            </button>
            {/* <button 
              onClick={() => setCurrentPage('portfolio')}
              className={`linkedin-nav-item ${currentPage === 'portfolio' ? 'active' : ''}`}
            >
              <Briefcase className="w-5 h-5" />
              <span className="text-xs mt-1">Portfolio</span>
            </button> */}
          </nav>

          {/* Profile/Auth */}
          <div className="flex items-center space-x-4 ml-5">
            {authStatus === false && (
              <div className="hidden lg:flex space-x-2">
                <button 
                  onClick={() => setCurrentPage('auth/login')}
                  className="linkedin-btn-secondary text-sm px-4 py-1.5"
                >
                  Sign in
                </button>
                <button 
                  onClick={() => setCurrentPage('auth/signup')}
                  className="linkedin-btn-primary text-sm px-4 py-1.5"
                >
                  Join now
                </button>
              </div>
            )}
            
            {authStatus === true && (
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 rounded-full bg-linkedin-blue flex items-center justify-center">
                  <span className="text-white text-sm font-medium">ME</span>
                </div>
                <button 
                  onClick={() => logOut()}
                  className="text-gray-600 hover:text-linkedin-blue text-sm"
                >
                  Sign out
                </button>
              </div>
            )}
            
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden p-2 text-gray-600"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4 space-y-2">
            {/* <div className="mb-4">
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full bg-gray-100 rounded px-4 py-2 text-sm focus:outline-none focus:bg-white"
              />
            </div> */}
            <button 
              onClick={() => setCurrentPage('feed')}
              className={`block w-full text-left px-4 py-2 text-sm ${['', 'feed'].includes(currentPage) ? 'text-linkedin-blue font-medium' : 'text-gray-700'}`}
            >
              Feed
            </button>
            <button 
              onClick={() => setCurrentPage('search')}
              className={`block w-full text-left px-4 py-2 text-sm ${currentPage === 'search' ? 'text-linkedin-blue font-medium' : 'text-gray-700'}`}
            >
              Search
            </button>
            <button 
              onClick={() => setCurrentPage('ratings')}
              className={`block w-full text-left px-4 py-2 text-sm ${currentPage === 'ratings' ? 'text-linkedin-blue font-medium' : 'text-gray-700'}`}
            >
              Rankings
            </button>
            <button 
              onClick={() => setCurrentPage('notifications')}
              className={`block w-full text-left px-4 py-2 text-sm ${currentPage === 'notifications' ? 'text-linkedin-blue font-medium' : 'text-gray-700'}`}
            >
              Notifications
            </button>
            <button 
              onClick={() => setCurrentPage('over-undervalued-companies')}
              className={`block w-full text-left px-4 py-2 text-sm ${currentPage === 'over-undervalued-companies' ? 'text-linkedin-blue font-medium' : 'text-gray-700'}`}
            >
              Undervalued
            </button>
            <button 
              onClick={() => setCurrentPage('subscriptions')}
              className={`block w-full text-left px-4 py-2 text-sm ${currentPage === 'ratings' ? 'text-linkedin-blue font-medium' : 'text-gray-700'}`}
            >
              Subscribe to Pro
            </button>
            {/* <button 
              onClick={() => setCurrentPage('portfolio')}
              className={`block w-full text-left px-4 py-2 text-sm ${currentPage === 'portfolio' ? 'text-linkedin-blue font-medium' : 'text-gray-700'}`}
            >
              Portfolio
            </button> */}

            {authStatus === false && (
              <div className="border-t border-gray-200 pt-4 mt-4 space-y-2">
                <button 
                  onClick={() => setCurrentPage('auth/login')}
                  className="block w-full linkedin-btn-secondary text-sm py-2"
                >
                  Sign in
                </button>
                <button 
                  onClick={() => setCurrentPage('auth/signup')}
                  className="block w-full linkedin-btn-primary text-sm py-2"
                >
                  Join now
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default LinkedInHeader;